function generateMixerTeams(
  playerIds,
  playerProfiles,
  playersPerTeam = 3,
  iterations = 5000
) {
  const totalPlayers = playerIds.length;
  const numTeams = Math.floor(totalPlayers / playersPerTeam);
  const players = playerIds.map((id) => ({
    id,
    skill: playerProfiles[id]?.skill ?? 5,
  }));

  // Shuffle utility
  function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  // Group into teams
  function chunk(arr, size) {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  }

  // Calculate variance of team skill totals
  function variance(teams) {
    const teamSums = teams.map((team) =>
      team.reduce((sum, p) => sum + p.skill, 0)
    );
    const avg = teamSums.reduce((a, b) => a + b, 0) / teamSums.length;
    return (
      teamSums.reduce((acc, sum) => acc + Math.pow(sum - avg, 2), 0) /
      teamSums.length
    );
  }

  // Swap two players between teams
  function swap(teams) {
    const newTeams = JSON.parse(JSON.stringify(teams));
    const teamA = Math.floor(Math.random() * newTeams.length);
    const teamB = Math.floor(Math.random() * newTeams.length);
    if (teamA === teamB) return newTeams;

    const playerA = Math.floor(Math.random() * newTeams[teamA].length);
    const playerB = Math.floor(Math.random() * newTeams[teamB].length);

    [newTeams[teamA][playerA], newTeams[teamB][playerB]] = [
      newTeams[teamB][playerB],
      newTeams[teamA][playerA],
    ];
    return newTeams;
  }

  // Initialize
  let bestTeams = chunk(shuffle([...players]), playersPerTeam);
  let bestVariance = variance(bestTeams);
  let temp = 1.0;

  for (let i = 0; i < iterations; i++) {
    const candidate = swap(bestTeams);
    const candidateVariance = variance(candidate);
    const delta = candidateVariance - bestVariance;

    if (delta < 0 || Math.random() < Math.exp(-delta / temp)) {
      bestTeams = candidate;
      bestVariance = candidateVariance;
    }

    // Cool down
    temp *= 0.995;
  }

  return bestTeams.map((team) => team.map((p) => p.id));
}

export default generateMixerTeams;
